import React from 'react'
import classNames from 'classnames'
import { Paper, Typography } from '@mui/material'
import {
  SELECT_CONDITION_DEVICE_STATE_TYPE,
  SELECT_CENTRAL_SCENE_STATE_SELECTED,
  SELECT_CENTRAL_SCENE_SUB_DEVICE_VALUE,
} from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import CardBlock from '@app/components/Common/iOS/CardBlockIOS/CardBlock'
import NavBar from '@app/components/Common/iOS/NavBarIOS/NavBar'
import PropTypes from '@app/components/PropTypes'
import getWallmoteButtonStates from '@app/helpers/scenes/getWallmoteButtonStates'

class SelectCentralSceneSubDevice extends React.Component {
  onBackClick = () => {
    const {
      navigate,
      isChangeSubDeviceMode,
      isEditConditionMode,
    } = this.props
    if (isEditConditionMode) {
      navigate(SELECT_CONDITION_DEVICE_STATE_TYPE)
    } else if (isChangeSubDeviceMode) {
      navigate(SELECT_CENTRAL_SCENE_STATE_SELECTED)
    } else {
      navigate(SELECT_CONDITION_DEVICE_STATE_TYPE)
    }
  }

  selectSubDevice=(subDeviceNumber) => {
    const {
      navigate,
      saveConditionDataNumber,
      isChangeSubDeviceMode,
      wallmoteSettings,
      saveConditionStateDescription,
      saveConditionDataValue,
    } = this.props
    const buttonStates = getWallmoteButtonStates(wallmoteSettings, subDeviceNumber)
    saveConditionDataNumber(subDeviceNumber)
    if (buttonStates.length === 1) {
      saveConditionStateDescription(buttonStates[0].description)
      saveConditionDataValue(buttonStates[0].value)
      navigate(SELECT_CENTRAL_SCENE_STATE_SELECTED)
    } else if (isChangeSubDeviceMode) {
      navigate(SELECT_CENTRAL_SCENE_STATE_SELECTED)
    } else {
      navigate(SELECT_CENTRAL_SCENE_SUB_DEVICE_VALUE)
    }
  }

  renderSubDevices=(subDevices) => (
    [...Array(subDevices)].map((el, index) => (
      <CardBlock
        key={`subDevice-${index + 1}`}
        description={`Button ${index + 1}`}
        position="middle"
        buttonName={I18n.t('scene_web.add')}
        isCardDisabled={false}
        isButtonDisabled={false}
        onClick={() => {
          this.selectSubDevice(index + 1)
        }}
      />
    )))

  render() {
    const {
      classes,
      isMobile,
      subDevicesAmount,
    } = this.props
    return (
      <Paper className={classNames(
        classes.wrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={() => {
            this.onBackClick()
          }}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_web.select_subdevice')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          {subDevicesAmount
            ? this.renderSubDevices(subDevicesAmount)
            : <Typography className={classes.somethingWrong}>{I18n.t('errors.something_went_wrong')}</Typography>}
        </Wrapper>
      </Paper>
    )
  }
}

SelectCentralSceneSubDevice.propTypes = {
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isEditConditionMode: PropTypes.bool.isRequired,
  saveConditionDataNumber: PropTypes.func.isRequired,
  subDevicesAmount: PropTypes.number.isRequired,
  isChangeSubDeviceMode: PropTypes.bool.isRequired,
  wallmoteSettings: PropTypes.arrayOf(PropTypes.shape({
    button_number: PropTypes.number.isRequired,
    press_settings: PropTypes.arrayOf(PropTypes.number.isRequired),
  })).isRequired,
  saveConditionStateDescription: PropTypes.func.isRequired,
  saveConditionDataValue: PropTypes.func.isRequired,
}

SelectCentralSceneSubDevice.displayName = 'SelectCentralSceneSubDeviceIOS'

export default SelectCentralSceneSubDevice
